import {useEffect, useRef} from "react";
import {observer} from "mobx-react";
import {GenericTabsNavigationItemRenderer} from "../../services/tabs-navigation/menu-items/generic-tabs-navigation-item.renderer";
import {TabsNavigationItemContainerBox} from "./boxes/item-container/tabs-navigation-item-container.box";
import {useServices} from "../../react-hooks/use-services.hook";
import {Image} from "../raw-components/image/image";
import {Link} from "../raw-components/link/link";
import {CyClass} from "../../../common/cy-classes";

interface TabsNavigationItemProps {
    menuItem: GenericTabsNavigationItemRenderer;
}

export const TabsNavigationItem: React.FC<TabsNavigationItemProps> = observer((props) => {
    const services = useServices();
    const elementRef = useRef<HTMLElement | null>(null);

    useEffect(() => {
        if (props.menuItem.isMatchToCurrentUrl && elementRef.current) {
            elementRef.current.scrollIntoView({behavior: "smooth", block: "nearest", inline: "center"});
        }
    }
    // since there is no dependency array this effect will run every render
    );

    const renderIcon = () => {
        if (!props.menuItem.iconSource || !props.menuItem.icon) {
            return null;
        }

        if (props.menuItem.iconSource === "themeIcons") {
            const Icon = services.theme.currentTheme.icons[props.menuItem.icon];
            if (!Icon) {
                services.logger.error(`Menu item ${props.menuItem.key} has configured icon ${props.menuItem.icon} which does not exist in currentTheme.icons`)

                return null;
            }

            return (<Icon size={2} title={props.menuItem.iconAltText ?? ''} />);
        } else if (props.menuItem.iconSource === 'themeImages') {
            const imageURI = props.menuItem.icon;
            if (!imageURI) {
                services.logger.error(`Menu item ${props.menuItem.key} has configured icon ${props.menuItem.icon} which does not exist in currentTheme.images`)
                return null;
            }
            return (<Image src={imageURI} alt={props.menuItem.iconAltText ?? ''} />)
        } else {
            return (<Image src={props.menuItem.icon} alt={props.menuItem.iconAltText ?? ''} />)
        }
    }

    const onClickHandler = async (e: Event) => {
        const currentPath = services.location.isHomePage ? 'Home' : services.location.getBasePath;
        (await services.tabsNavigation).sendOrbitUserFlowAnalytics(props.menuItem.originalText, currentPath);
        await props.menuItem.execute();
    }

    let href = props.menuItem.getLinkUrl() ?? '';
    if (href) {
        href = services.location.buildFullUri(href).toString();
    }

    return (
        <Link href={decodeURI(encodeURI(href))} onClick={onClickHandler} className={CyClass('cy-tabs-navigation-menu-item')} ref={elementRef}>
            <TabsNavigationItemContainerBox isActive={props.menuItem.isMatchToCurrentUrl}>
                {renderIcon()}
                {props.menuItem.text}
            </TabsNavigationItemContainerBox>
        </Link>
    )
})
